import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import { getShiftType, updateShiftType } from '../../actions/shiftTypeActions';
import { getCompanies } from "../../actions/companyActions";
import { getShiftType } from "../../actions/shiftTypeActions";
import { createShiftTypeCompany } from "../../actions/shiftTypeCompanyActions";
import {
  Grid,
  TextField,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import Form from "./Form";

class CreateShiftTypeCompanyForm extends Component {
  state = {
    shiftType: { name: "" },
    companyEmail: "",
    price: "",

    optionCompanies: [],
  };

  componentDidMount() {
    this.props
      .getShiftType(this.props.shiftTypeId)
      .then((shiftType) => this.setState({ shiftType }));

    this.props.getCompanies().then((optionCompanies) => {
      this.setState({ optionCompanies });
    });
  }

  createShiftTypeCompany = (e) => {
    e.preventDefault();
    this.props
      .createShiftTypeCompany(this.props.shiftTypeId, this.state)
      .then(
        () =>
          (window.location.href = `/shifttype/${this.props.shiftTypeId}/update`),
      );
  };

  handleCompanyChange = (e) => {
    this.setState({ companyEmail: e.target.value, employees: [] });
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handlePriceChange = (e) =>
    this.setState({ [e.target.name]: parseFloat(e.target.value).toFixed(2) });

  render() {
    return (
      // <Form onSubmit={this.updateShiftTypeCompany} submitText="Wijzigen" isFetching={this.props.isFetching} successMessage={this.props.successMessage} errorMessage={this.props.errorMessage}>
      <Form
        onSubmit={this.createShiftTypeCompany}
        submitText="Toevoegen"
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              id="shiftType"
              name="shiftType"
              label="Dienstsoort *"
              value={this.state.shiftType.name}
              disabled
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Fragment>
              <InputLabel htmlFor="company">Bedrijf *</InputLabel>
              <Select
                id="company"
                name="company"
                value={this.state.companyEmail}
                onChange={this.handleCompanyChange}
                fullWidth
              >
                {this.state.optionCompanies.map((company) => (
                  <MenuItem
                    key={company.email}
                    value={company.email}
                    style={{
                      fontWeight:
                        this.state.companyEmail != company.email
                          ? "normal"
                          : "500",
                    }}
                  >
                    {company.name}
                  </MenuItem>
                ))}
              </Select>
            </Fragment>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="price"
              name="price"
              type="number"
              label="Uurtarief *"
              value={this.state.price}
              onChange={this.handleChange}
              onBlur={this.handlePriceChange}
              fullWidth
              InputProps={{
                min: ".01",
                step: ".01",
                startAdornment: (
                  <InputAdornment position="start">€</InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Form>
    );
  }
}

CreateShiftTypeCompanyForm.propTypes = {
  //     id: PropTypes.string.isRequired,
  //     getShiftType: PropTypes.func.isRequired,
  shiftTypeId: PropTypes.string.isRequired,
  getShiftType: PropTypes.func.isRequired,
  getCompanies: PropTypes.func.isRequired,
  createShiftTypeCompany: PropTypes.func.isRequired,
  //     updateShiftType: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.shiftTypeCompany.createShiftTypeCompany.successMessage,
  errorMessage:
    state.company.getCompanies.errorMessage ||
    state.shiftTypeCompany.createShiftTypeCompany.errorMessage, //state.shifttype.updateShiftType.errorMessage,
  isFetching:
    state.company.getCompanies.isFetching ||
    state.shiftTypeCompany.createShiftTypeCompany.isFetching, //state.shifttype.getShiftType.isFetching || state.shifttype.updateShiftType.isFetching
});

export default connect(mapStateToProps, {
  getShiftType,
  getCompanies,
  createShiftTypeCompany,
})(CreateShiftTypeCompanyForm);



// WEBPACK FOOTER //
// ./src/components/forms/CreateShiftTypeCompanyForm.js